export var rolDataForm = {
    id: "",
    clientId: "",
    RolName: "",
    RolDescription: "",
};
export var ColumnsPermissions = function (clickContextMenuPaymentMode) {
    return [
        {
            editable: false,
            field: "name",
            flex: 1,
            headerName: "Nombre",
            width: 150,
        },
        {
            editable: false,
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
        {
            editable: false,
            field: "type",
            flex: 1,
            headerName: "Tipo",
            width: 160,
        },
        {
            editable: false,
            field: "enabled",
            flex: 1,
            headerName: "Activo",
            width: 160,
        },
    ];
};
